package floris.graphics.backoffice.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.materialdesignsystem.toColorScheme
import floris.graphics.core.Constants
import floris.graphics.core.constants.Res
import org.jetbrains.compose.web.css.CSSNumericValue
import org.jetbrains.compose.web.css.CSSUnitLengthOrPercentage
import org.jetbrains.compose.web.css.px

@Composable
fun FooterSection() {
    val colorScheme = ColorMode.current.toColorScheme
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .maxWidth(Constants.SECTION_WIDTH.px)
            .padding(top = 32.px, bottom = 32.px),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                modifier = Modifier
                    .fontSize(14.px)
                    .color(colorScheme.onBackground.toRgb().copyf(alpha = 0.25f)),
                text = Res.String.Copyright
            )
            SpanText(
                modifier = Modifier
                    .margin(top = 6.px)
                    .fontSize(14.px)
                    .color(colorScheme.onBackground.toRgb().copyf(alpha = 0.25f)),
                text = Res.String.WebsiteCreatedBy
            )
        }
    }
}
